import { render } from "./CommentTask.vue?vue&type=template&id=6d0ff25d"
import script from "./CommentTask.vue?vue&type=script&lang=js"
export * from "./CommentTask.vue?vue&type=script&lang=js"

import "./CommentTask.vue?vue&type=style&index=0&id=6d0ff25d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__